var _polygon, _polygon2, _polygon3, _polygon4, _polygon5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoAvaya(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "All_Logos",
    "data-name": "All Logos",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 380 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo_avaya") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "297.54 87.72 319.25 87.72 322.76 96.41 293.47 96.41 288.8 106.39 275.86 106.39 307.94 40.66 316.89 40.66 348.95 106.39 336.03 106.39 312.41 55.64 297.54 87.72 297.54 87.72 297.54 87.72",
    fill: "#d00000",
    fillRule: "evenodd"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "52.74 88.21 74.44 88.21 77.95 96.9 48.66 96.9 43.99 106.88 31.05 106.88 63.13 41.14 72.08 41.14 104.14 106.88 91.22 106.88 67.59 56.12 52.74 88.21 52.74 88.21 52.74 88.21",
    fill: "#d00000",
    fillRule: "evenodd"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "174.69 88.21 196.38 88.21 199.89 96.9 170.61 96.9 165.93 106.88 153 106.88 185.07 41.14 194.03 41.14 226.09 106.88 213.17 106.88 189.55 56.12 174.69 88.21 174.69 88.21 174.69 88.21",
    fill: "#d00000",
    fillRule: "evenodd"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "92.06 40.93 124.12 106.66 124.65 106.66 132.53 106.66 133.07 106.66 165.14 40.93 152.22 40.93 128.6 92.65 104.98 40.93 92.06 40.93 92.06 40.93 92.06 40.93",
    fill: "#d00000",
    fillRule: "evenodd"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "244 131.34 288.25 40.93 275.36 40.93 250.75 93.61 228.1 40.93 215.18 40.93 244.34 106.66 231.63 131.34 244 131.34 244 131.34 244 131.34",
    fill: "#d00000",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAvaya);
export default __webpack_public_path__ + "static/media/logo_avaya.b5d86c2331de2eeb1891bfcd4bd2e43f.svg";
export { ForwardRef as ReactComponent };